import { createContext, useContext } from 'react';

export type AuthContextValue = {
  retrieveAccessToken: () => Promise<string>;
  logout: () => Promise<void>;
};

const AuthContext = createContext<AuthContextValue | null>(null);

/**
 * Use this hook to check if auth context exists.
 * This should not be used by most consumers.
 */
const useOptionalAuthContext = () => {
  return useContext(AuthContext);
};

const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within an AuthContextProvider');
  }

  return context;
};

const AuthContextProvider = AuthContext.Provider;

export { AuthContextProvider, useAuthContext, useOptionalAuthContext };
